import { ProductCarousel } from '@mweb/zappos-ui/ProductCarousel';
import type { MouseEventHandler } from 'react';

import useMartyContext from 'hooks/useMartyContext';

interface SponsoredBrandsCarouselProps {
  heading: string | null;
  slides: React.ReactNode[];
  overrides?: {
    root?: string;
    item?: string;
    backButton?: string;
    forwardButton?: string;
  };
  forwardButtonOnClick?: MouseEventHandler<HTMLButtonElement>;
}

const SponsoredBrandsCarousel = (props: SponsoredBrandsCarouselProps) => {
  const { heading, slides, overrides, forwardButtonOnClick } = props;
  const { testId } = useMartyContext();

  return (
    <section className="flex flex-col gap-4" data-test-id={testId('sponsoredBrandsCarousel')}>
      <h2 className="text-xl/none font-semibold">{heading}</h2>
      <ProductCarousel overrides={overrides} options={{ slidesToScroll: 1 }} slides={slides} forwardButtonOnClick={forwardButtonOnClick} />
    </section>
  );
};

export default SponsoredBrandsCarousel;
